import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import * as moment from 'moment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = {};
    if (localStorage.expires_in) {
      const expires_date = new Date(parseInt(atob(localStorage.expires_in)));
      const expires_valide = moment().isAfter(moment(expires_date));
      if ( expires_valide ) {
        localStorage.clear();
        window.location.reload();
      }
    }
    const access_token = localStorage.getItem('myAppAccess');
    if ( access_token !== null) {
      const token1 = access_token.substring(0, access_token.length / 2);
      const token2 = access_token.substring(access_token.length / 2, access_token.length);
      headers = {
        'Content-Type' : 'application/json; charset=utf-8',
        'Accept'       : 'application/json',
        'Intelcia1'     : token1,
        'Intelcia2'     : token2
      };
    }
    if (!req.url.endsWith('injectionCsvManager')) {
      req = req.clone({
        setHeaders: headers,
      });
    }
    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptor/auth-interceptor.ts